import React from 'react';
import {Modal, ScrollView, Text, View} from 'react-native';
import Button from '../../../../components/Button';
import Div from '../../../../lib/Div';
import MainStyle from '../../../../../MainStyle';
import {colors} from '../../../../assets/styles/colors';
import P from "../../../../lib/P";
import {isFullSwing} from "../../../../constants";

type Props = { isOpen: boolean, onClose: () => void, startNewChallenge: () => void };

const ChallengeFull = (props: Props) => {
  const {isOpen} = props;

  return (
    <Modal animationType="fade" transparent visible={isOpen} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <View style={[MainStyle.min_h_full, MainStyle.a_i_c, MainStyle.j_c_c]}>
            <Div w={390} h={452} rounded={20} borderWidth={1} borderColor={colors.settings_border}
                 bg={isFullSwing ? '#131314' : colors.settings_bg} py={isFullSwing ? 0 : 43} alignItems="center"
                 overflow="hidden">
              <P fw="500" fs={26} lh={isFullSwing ? 48 : 26} mb={38} bg={isFullSwing ? '#252526' : undefined} w="100%"
                 ta="center">
                Challenge Full
              </P>

              <Text style={styles.message}>Sorry but this Friend Challenge is full of players.</Text>

              <Button
                onPress={props.onClose} text="Enter Another Challenge" w={309} color={isFullSwing ? 'white' : undefined}
                fontWeight="600" mb={13} bg={isFullSwing ? '#3369FF' : undefined} radius={isFullSwing ? 4 : undefined}
              />

              <Button
                text="Start New Friend Challenge" bg={isFullSwing ? '#252526' : colors.mainBackground} borderWidth={1}
                borderColor={isFullSwing ? '#4C4C4C' : 'white'} color="white" w={309} fontWeight="600" mb={13}
                radius={isFullSwing ? 4 : undefined}
                onPress={() => {
                  props.onClose();
                  props.startNewChallenge();
                }}
              />

              <Button
                onPress={props.onClose} text="Cancel" bg={isFullSwing ? '#252526' : colors.mainBackground}
                borderWidth={1} borderColor={isFullSwing ? '#4C4C4C' : 'white'} radius={isFullSwing ? 4 : undefined}
                color="white" w={309} fontWeight="600"
              />
            </Div>
          </View>
        </ScrollView>
      </View>
    </Modal>
  );
};

const styles = {
  message: [
    MainStyle.c_white, MainStyle.Barlow500, MainStyle.f_s_22, MainStyle.m_b_32, MainStyle.t_a_c, MainStyle.w_300
  ]
}

export default React.memo(ChallengeFull);
